var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuta1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 519.41 521.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#757575;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 111") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.5,0A81.49,81.49,0,0,0,0,81.49c0,45,81.5,130.86,81.5,130.86S163,126.5,163,81.49A81.49,81.49,0,0,0,81.5,0Zm0,115.89A41.3,41.3,0,1,1,122.79,74.6,41.29,41.29,0,0,1,81.5,115.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.91,308.85a81.49,81.49,0,0,0-81.49,81.5c0,45,81.49,130.86,81.49,130.86s81.5-85.85,81.5-130.86A81.5,81.5,0,0,0,437.91,308.85Zm0,115.89a41.29,41.29,0,1,1,41.3-41.29A41.29,41.29,0,0,1,437.91,424.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.11,103a99.4,99.4,0,0,1,15-3.29c1.27-.2,2.54-.34,3.81-.49s2.55-.32,3.82-.43l3.84-.31,3.84-.23c2.56-.14,5.11-.13,7.69-.2s5.14,0,7.71.12,5.15.24,7.71.45,5.14.44,7.7.75a207.41,207.41,0,0,1,59.92,16.53,212.35,212.35,0,0,1,27.68,15c4.39,2.89,8.76,5.81,12.91,9,4.27,3.07,8.21,6.57,12.23,10a201.2,201.2,0,0,1,39.63,48.28L396.73,212a379.54,379.54,0,0,0-41.17-37.72c-3.7-2.75-7.28-5.64-11.09-8.23l-2.81-2c-.92-.69-1.85-1.36-2.82-2-1.93-1.27-3.84-2.54-5.74-3.84s-3.91-2.42-5.84-3.68l-2.92-1.85-3-1.74c-2-1.16-3.95-2.4-6-3.51l-6.06-3.37a418,418,0,0,0-51.22-23.24c-8.93-3.37-18-6.57-27.34-9.5S212,105.58,202.11,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.91,260.87c-24.92-20.42-60.36-43.14-89.58-53l52.92-9.74,34.44-41.33C429.93,187.12,432.33,229.14,437.91,260.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275,423.72A99,99,0,0,1,260,427c-1.27.2-2.54.33-3.81.49s-2.55.32-3.83.43l-3.83.31-3.84.23c-2.56.14-5.12.13-7.69.19s-5.14-.05-7.71-.11-5.15-.24-7.71-.46-5.14-.44-7.7-.75A207.39,207.39,0,0,1,154,410.82a213.56,213.56,0,0,1-27.68-14.95c-4.39-2.89-8.76-5.81-12.92-9.05-4.26-3.08-8.2-6.58-12.23-9.95a201.36,201.36,0,0,1-39.62-48.28L80.4,314.67a381.6,381.6,0,0,0,41.18,37.72c3.7,2.75,7.28,5.63,11.09,8.23l2.8,2c.93.68,1.86,1.35,2.83,2,1.92,1.26,3.84,2.53,5.74,3.83s3.91,2.43,5.84,3.69l2.91,1.85,3,1.74c2,1.16,3.95,2.39,6,3.5l6.06,3.37A418.88,418.88,0,0,0,219,405.82c8.92,3.37,18,6.57,27.34,9.5S265.15,421.09,275,423.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.23,265.79c24.92,20.43,60.36,43.14,89.58,53L75.88,328.5,41.44,369.84C47.21,339.55,44.8,297.53,39.23,265.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuta1);
export default __webpack_public_path__ + "static/media/ruta1.374c986c.svg";
export { ForwardRef as ReactComponent };